import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@store'
import { allRoutes } from './routes'
import NProgress from 'nprogress/nprogress'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: allRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some(record => record.meta.authRequired)
  const isAuthenticated  = store.getters['auth/isAuthenticated']
  document.title = 'Talent' + (to.name ? ' | ' + to.name : '');
  if (from.name !== null) {
    // Start the route progress bar.
    NProgress.start()
  }
  // if(role_modules.some(item => item.value == to.meta.module) && !!to.meta.module)
  //   notFound()

  if (!authRequired) return next()

  if (isAuthenticated) {
    return store.dispatch('auth/validate').then((validUser) => {
      if(!to.meta.module)
        return next()

      console.log(validUser.role_modules)
      validUser ? ((validUser.role_modules.modules.some(item => item.value == to.meta.module) && !!to.meta.module) ? next() : notFound()) : redirectToLogin()
    }).catch(() => {
      // If validate fails (401, etc.), redirect to login
      return redirectToLogin();
    });
  }

  redirectToLogin()

  function redirectToLogin() {
    next({ name: 'login', query: { redirectFrom: to.fullPath } })
  }

  function notFound() {
    next({ name: '404', query: { redirectFrom: to.fullPath } })
  }
})

router.beforeResolve(async (to, routeFrom, next) => {

  try {
    // For each matched route...
    for (const route of to.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(to, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              if (routeFrom.name === args[0].name) {
                // Complete the animation of the route progress bar.
                NProgress.done()
              }
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

router.afterEach(() => {
  NProgress.done()
})


export default router
